class Accounts {
  constructor() {
    this.init()
  }

  init () {
    this.cacheDOM()
    this.bindEvents()
  }

  cacheDOM () {

  }

  bindEvents () {

  }

}

window.Accounts = Accounts
